import { clamp } from '~~/common/js/universal/utils';

/**
 * adds a `scrollIntoParentView` method,
 * which acts as the standard `scrollIntoView`
 * but with respect to the item's `offsetParent`,
 * or the override parent provided as the 1st argument.
 * It uses the root element of the component as the target.
 *
 * (elsewhere in code):
 * ```js
 * // scroll relative to the offsetParent
 * myComponent.scrollIntoParentView();
 * // scroll relative to specific scrolling parent
 * myComponent.scrollIntoParentView(myContainer);
 * ```
 */
export default {
  methods: {
    scrollIntoParentView(overrideParent) {
      const item = this.$el;
      const parent = overrideParent || item.offsetParent;
      if (!parent) {
        return;
      }

      const itemBottom = item.offsetTop + item.offsetHeight;
      parent.scrollTop = clamp(
        parent.scrollTop,
        itemBottom - parent.offsetHeight,
        item.offsetTop);
    },
  },
};
